var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongGaojisousuo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H3a.5.5 0 01-.5-.5v-11A.5.5 0 013 2h10a.5.5 0 01.5.5V8M5 5h6M5 8h3",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.333,
    cy: 11.629,
    r: 2.25,
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.58 13.169a.5.5 0 10-.708.707l.707-.707zm.07 1.485a.5.5 0 00.707-.707l-.707.707zm-.778-.778l.778.778.707-.707-.778-.778-.707.707z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_gaojisousuo.2c398214.svg";
export { SvgTongyongGaojisousuo as ReactComponent };